export default __webpack_public_path__ + "static/media/latribu-vr-white.98d207e7.svg";